import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/main-home.css"
import Chat from "../../components/chat/Chat";
import { sendChatMessage } from "../../services/chatService";
import { useAuth } from "../../context/AuthContext";

const Home = () => {

  const { userId } = useAuth();
  const loggedIn = !!userId;

  const handleLandingAI = async (userMessage, chatHistory) => {
    try {
      const history = chatHistory.map((msg) => ({
        role: msg.from === "user" ? "user" : "assistant",
        content: msg.text,
      }));

      const response = await sendChatMessage({
        message: userMessage,
        history,
      });

      // 🔥 EXTRACT THE STRING
      return {
        aiResponse: response.aiResponse,
        freelancers: response.freelancers,
        businesses: response.businesses
      };
    } catch (error) {
      console.error(error);
      return "Sorry — I had trouble responding just now.";
    }
  };

  return (
    <div id="content-scroll">
      <div className="main-home ai-contact">
        <Chat
          mode="user"
          initialMessages={[
            {
              from: "ai",
              text: "Hey there 👋 I'm your ServSpace AI assistant. How can I help today?",
            },
          ]}
          onSendMessage={handleLandingAI}
          placeholder="Ask about our services..."
          loggedIn={loggedIn}
        />
      </div>
    </div>
  );
};

export default Home;